<span class="notification-row" [class.notification-row--unread]="!row().item.seen">
  @if (!row().item.seen) {
    <span class="notification-row-unread-label" [attr.data-test]="'notification-row-unread-' + row().item.id">
      {{ "knowledge.notifications.unread" | translate }}
    </span>
  }

  @if (row().reactionKey) {
    <span
      class="notification-row-glyph material-symbols-outlined"
      [matTooltip]="row().reactionKey! | translate"
      [attr.aria-label]="row().reactionKey! | translate">
      {{ row().icon }}
    </span>
  } @else {
    <span class="notification-row-glyph material-symbols-outlined" aria-hidden="true">{{ row().icon }}</span>
  }

  <span class="notification-row-body">
    <span class="notification-row-text">{{ row().textKey | translate: row().textParams }}</span>

    @if (row().item.targetTitle) {
      <span class="notification-row-title">&ldquo;{{ row().item.targetTitle }}&rdquo;</span>
    }
  </span>

  <span class="notification-row-time">
    @if (row().time.key) {
      {{ row().time.key! | translate: row().time.params }}
    } @else {
      {{ row().item.createdAt | date: "mediumDate" }}
    }
  </span>
</span>
